// LockModal — State C dialog: "This draft is currently being edited by {holder}."
// Options: "Wait" (close, page polls) | "Take over" (acquire?takeover=true).
//
// Keyboard accessible: Escape closes (treated as "Wait"), Enter on a button
// activates it.

import { useEffect } from 'react';

interface LockModalProps {
  open: boolean;
  holderDisplay: string | null;
  holderEmail: string | null;
  onWait: () => void;
  onTakeover: () => void;
}

export function LockModal({
  open,
  holderDisplay,
  holderEmail,
  onWait,
  onTakeover,
}: LockModalProps): React.JSX.Element | null {
  // Escape closes the modal (= Wait — keep polling).
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onWait();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onWait]);

  if (!open) return null;

  const labelBits: string[] = [];
  if (holderDisplay) labelBits.push(holderDisplay);
  if (holderEmail) labelBits.push(`(${holderEmail})`);
  const holderLabel = labelBits.length ? labelBits.join(' ') : 'another user';

  return (
    <>
      <div className="modal-backdrop" onClick={onWait} />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="lock-modal-title"
        className="modal"
        data-size="sm"
      >
        <div className="modal-header">
          <h2 id="lock-modal-title" className="modal-title">
            Draft is being edited
          </h2>
        </div>
        <div className="modal-body">
          This draft is currently being edited by {holderLabel}.
        </div>
        <div className="modal-footer">
          <button type="button" className="btn" data-variant="secondary" onClick={onWait}>
            Wait
          </button>
          <button type="button" className="btn" data-variant="danger" onClick={onTakeover}>
            Take over
          </button>
        </div>
      </div>
    </>
  );
}
